import { api, call, xClient } from "@/api/spec";
import type { PurchaseResponse } from "@/api/types";
import type { PurchaseResult } from "@/platform";

/** 스토어별 검증 엔드포인트로 증빙 제출(AC0-179). 서버가 멱등이라 같은 증빙 재제출은 already_granted. */
export function submitPurchase(p: PurchaseResult): Promise<PurchaseResponse> {
  const params = { header: xClient() };
  return p.store === "apple"
    ? call(api.POST("/purchases/apple", { params, body: { signedTransaction: p.signedTransaction, productId: p.productId } }))
    : call(api.POST("/purchases/google", { params, body: { purchaseToken: p.purchaseToken, productId: p.productId } }));
}
